import {createOutboxCascade} from 'src/offline/pendingUploads';
import {actionUploadRefs} from './appliers';
import {TASK_OUTBOX_KINDS} from './outboxKinds';

/** A queued Action create is one unit of work with its inline-attachment uploads. */
export const actionCreateCascade = createOutboxCascade({
  kind: TASK_OUTBOX_KINDS.create,
  extractRefs: actionUploadRefs,
});

/** A queued transition carries no uploads; the cascade keeps one call shape. */
export const taskTransitionCascade = createOutboxCascade({
  kind: TASK_OUTBOX_KINDS.transition,
  extractRefs: () => [],
});
